import { render } from "./world-standing.vue?vue&type=template&id=6045cc44"
import script from "./world-standing.vue?vue&type=script&lang=js"
export * from "./world-standing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__